export default __webpack_public_path__ + "static/media/sunnyside.a321a09c.png";